import React from 'react';
import { servicesIcons, servicesPhotos, services } from 'lib/constants';
import Button from 'commonComponents/Button/Button';
import { getServiceLink } from 'lib/utils/urlUtils.js';
import styles from './ServiceBox.module.scss';

const ServiceBox = ({ title, subtitle, text, button, index }) => {
  const service = services[index];

  return (
    <div className={ styles.ServiceBox }>
      <figure>
        <img src={ servicesPhotos[service] } />
      </figure>
      <article className={ styles.content }>
        <div className={ styles.header }>
          <img src={ servicesIcons[service] } className={ styles.icon} />
          <div className={ styles.titles }>
            <h3>{ title }</h3>
            <h4>{ subtitle }</h4>
          </div>
        </div>
        <p className={ styles.text }>{ text }</p>
        <Button label={ button } link={ getServiceLink(service) }
          type="narrow"
        />
      </article>
    </div>
  );
};

export default ServiceBox;
